export default __webpack_public_path__ + "static/media/pin50.7bde2624.svg";